import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class MeasurerId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): MeasurerId {
    if (!(value.length > 0)) {
      throw new Error('内容が入力されていません');
    }
    return new MeasurerId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
